import { makePostCall } from 'frontend/core/src/data/util';
import { graphql } from 'frontend/core/src/graphqlTypes/graphql';
import { hostUrl } from 'frontend/core/src/utils/getServerUrl';

export const UpdatePasswordQuery = graphql(`
  mutation changePassword($currentPassword: String!, $newPassword: String!) {
    changePassword(currentPassword: $currentPassword, newPassword: $newPassword)
  }
`);

export const DeleteAccountCleanupQuery = graphql(`
  query CleanupPreview {
    cleanupPreview {
      _id
      entityKind
      name
    }
  }
`);

/*
 * @deprecated - use this instead: deleteUserAccount
 */
export const DeleteAccountQuery = graphql(`
  mutation cleanup {
    cleanup {
      entityKind
    }
  }
`);

export const AddUserAttributeQuery = graphql(`
  mutation addUserAttribute($uid: String!, $attribute: UserAttributeType!) {
    addUserAttribute(uid: $uid, attribute: $attribute)
  }
`);

export const DeleteUserAttributeQuery = graphql(`
  mutation deleteUserAttribute($uid: String!, $attribute: UserAttributeType!) {
    deleteUserAttribute(uid: $uid, attribute: $attribute)
  }
`);

const DeleteUserAccountAPI = '/api/deleteUser';
export const deleteUserAccount = async () => {
  return await makePostCall(hostUrl + DeleteUserAccountAPI, {});
};
